import Button from '../../components/button/Button';
import { WellDoneSVG } from '../../assets/SVGAssets';
import { GoodTrySVG } from '../../assets/SVGAssets';

import './answer.css';

export default function Answer({
    status,
    description,
    descriptionImage,
    descriptionConditions,
    next,
}) {
    const strings = description.split('<br>');
    return (
        <div className="answerWrapper">
            <div className="answerBorders">
                <div className="answer-border top-left"></div>
                <div className="answer-border top-right"></div>
                <div className="answer-border bottom-left"></div>
                <div className="answer-border bottom-right"></div>
            </div>

            <div className="answerTitle">
                {status ? <WellDoneSVG /> : <GoodTrySVG />}
                <span>{status ? 'well done !' : 'Good try'}</span>
            </div>

            <div className="answerContentWrapper">
                <div className={`answerContent ${descriptionConditions}`}>
                    {descriptionImage && (
                        <img src={descriptionImage} alt={description} />
                    )}

                    <div className="answerContentText">
                        <h2>You are {status ? 'correct' : 'incorrect'}</h2>

                        {strings.map((string, i) => {
                            const st = string.split('  ');
                            if (st.length === 2) {
                                return (
                                    <p key={i} className="subtext">
                                        {st[1]}
                                    </p>
                                );
                            } else {
                                return <p key={i}>{st[0]}</p>;
                            }
                        })}
                    </div>
                </div>
            </div>
            <div className="answerNext">
                <Button type={'nextButton'} text={'next'} action={next} />
            </div>
        </div>
    );
}
